module.exports = __webpack_public_path__ + "static/media/flower.9fa38c13.svg";